module.exports = __webpack_public_path__ + "static/media/MORARA.6fb73c78.mp4";